import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useContext, useState } from 'react';
import '../../App.css';
import { StyleConstants } from '../../Styles';
import RestfulManager, { RES_STATUS_OK } from '../../manager/RestfulManager';
import SnackbarContext from '../../components/SnackbarContext';
import SessionManager from '../../manager/SessionManager';

const ProfilePage = () => {
    const { setOpenSnackBar, setSnackbarSeverity, setSnackbarMessage } = useContext(SnackbarContext);

    const sessionManager = new SessionManager();
    const restfulManager = new RestfulManager();

    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const changePassword = () => {
        (async () => {
            if (password !== confirmPassword) {
                setSnackbarMessage('The new password does not match the confirm new password.');
                setOpenSnackBar(true);
                return;
            }

            const res = await restfulManager.changePassword(sessionManager.getAccessToken(), {
                oldPassword: oldPassword,
                password: password
            });

            const json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setSnackbarSeverity('success');
                setSnackbarMessage('The password has been updated.');
            } else {
                setSnackbarSeverity('error');
                setSnackbarMessage(json.msg);
            }
            setOpenSnackBar(true);
        })();
    };

    return (
        <>
            <Box sx={{ flexGrow: 1, padding: '8px' }}>
                <Stack direction="column">
                    <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                        <Typography sx={{ color: StyleConstants.fontColor, fontSize: 24, marginRight: '8px', width: '170px' }}>
                            Old Password:
                        </Typography>
                        <TextField
                            variant='outlined'
                            type='password'
                            size='small'
                            sx={{
                                width: '400px',
                                border: '1px solid ' + StyleConstants.borderColor,
                            }}
                            inputProps={{
                                maxLength: 20,
                                style: {
                                    color: StyleConstants.borderColor,
                                    fontSize: 24,
                                }
                            }}
                            value={oldPassword}
                            onChange={e => {
                                setOldPassword(e.target.value);
                            }}
                        />
                    </Stack>

                    <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                        <Typography sx={{ color: StyleConstants.fontColor, fontSize: 24, marginRight: '8px', width: '170px' }}>
                            New Password:
                        </Typography>
                        <TextField
                            variant='outlined'
                            type='password'
                            size='small'
                            sx={{
                                width: '400px',
                                border: '1px solid ' + StyleConstants.borderColor,
                            }}
                            inputProps={{
                                maxLength: 20,
                                style: {
                                    color: StyleConstants.borderColor,
                                    fontSize: 24,
                                }
                            }}
                            value={password}
                            onChange={e => {
                                setPassword(e.target.value);
                            }}
                        />
                    </Stack>

                    <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                        <Typography sx={{ color: StyleConstants.fontColor, fontSize: 24, marginRight: '8px', width: '170px' }}>
                            Confirm New Password:
                        </Typography>
                        <TextField
                            variant='outlined'
                            type='password'
                            size='small'
                            sx={{
                                width: '400px',
                                border: '1px solid ' + StyleConstants.borderColor,
                            }}
                            inputProps={{
                                maxLength: 20,
                                style: {
                                    color: StyleConstants.borderColor,
                                    fontSize: 24,
                                }
                            }}
                            value={confirmPassword}
                            onChange={e => {
                                setConfirmPassword(e.target.value);
                            }}
                        />
                    </Stack>

                    <Button
                        onClick={() => {
                            changePassword();
                        }}
                        sx={{ marginTop: '8px', width: '700px', backgroundColor: StyleConstants.componentBgColor, color: StyleConstants.fontColor }}
                    >
                        <Typography sx={{ color: StyleConstants.fontColor, fontSize: 24 }}>
                            Change Password
                        </Typography>
                    </Button>
                </Stack>
            </Box>
        </>
    );
};

export default ProfilePage;